<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" [routerLink]="'/settings'" />
    </ion-buttons>
    <ion-title>{{ 'SETTINGS.TREATMENT_PLACE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-radio-group (ionChange)="setTreatmentPlace($event)" [value]="currentTreatmentPlace()">
      <ion-item>
        <ion-radio [translate]="'SETTINGS.RIGET'" justify="start" label-placement="end" value="riget" />
      </ion-item>
      <ion-item>
        <ion-radio [translate]="'SETTINGS.HERNING'" justify="start" label-placement="end" value="herning" />
      </ion-item>
      <ion-item>
        <ion-radio [translate]="'SETTINGS.ANDET'" justify="start" label-placement="end" value="andet" />
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
